import React, { forwardRef } from 'react'
import moment from 'moment'
import { DatePicker } from 'antd'
// import DatePicker from 'react-datepicker'

import { stringifyDate } from '../../modules'

const Datepicker = ({ placeholder="Day/Month/Year", picker, className = "w-full", showTime = false, value, onChange, disabled, disabledDate = null, onBlur, format="DD/MM/YYYY HH:mm" }) => 
    <div className={ `appearance-none block ${className} bg-gray-200 text-gray-700 border border-gray-200 rounded px-1 py-1.5 mb-3 leading-tight focus:outline-none focus:bg-white` }>
        <DatePicker 
            format={format}
            bordered={false} 
            picker={ picker }
            onBlur={ onBlur }
            showTime={ showTime }
            disabled={ disabled }
            className={ className }
            placeholder={ placeholder }
            disabledDate={ disabledDate }
            onChange={ val => onChange(val?._d) }
            value={ value ? moment(value) : null }
        />
    </div>

export default Datepicker